<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-xl font-semibold mb-4">Копирование шага</h2>

      <!-- Название -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Название *</label>
        <input
          v-model="form.name"
          type="text"
          maxlength="255"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Введите название шага"
        />
      </div>

      <!-- Тип шага -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Тип шага *</label>
        <select
          v-model="form.type"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option v-for="t in stepTypes" :key="t" :value="t">{{ getStepTypeName(t) }}</option>
        </select>
      </div>

      <!-- Операция -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Операция *</label>
        <select
          v-model="form.targetOperationId"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option :value="null">— выберите операцию —</option>
          <option v-for="op in operationOptions" :key="op.id" :value="op.id">
            {{ op.label }}
          </option>
        </select>
      </div>

      <!-- Ошибка -->
      <div v-if="error" class="text-red-500 text-sm mb-4">{{ error }}</div>

      <!-- Кнопки -->
      <div class="flex justify-end space-x-3">
        <button
          type="button"
          class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
          @click="$emit('close')"
        >
          Отмена
        </button>
        <button
          type="button"
          class="px-4 py-2 rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
          @click="submit"
        >
          Скопировать
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyStepModal',
  props: {
    step: { type: Object, required: true },
    technologies: { type: Array, default: () => [] },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      stepTypes: ['production', 'print', 'packaging', 'picking', 'additional', 'software'],
      form: {
        name: this.step?.name ? `${this.step.name} (копия)` : '',
        type: this.step?.type || 'production',
        targetOperationId: null,
      },
      error: '',
    };
  },
  computed: {
    operationOptions() {
      const result = [];
      (this.technologies || []).forEach((component) => {
        const tech = component.technology || component;
        const techName = tech?.name || '';
        const operations = tech?.operations || [];
        operations.forEach((op) => {
          result.push({
            id: op.id,
            label: techName ? `${techName} → ${op.name}` : op.name,
          });
        });
      });
      return result;
    },
  },
  methods: {
    getStepTypeName(type) {
      const names = {
        production: 'Производственный',
        print: 'Печать',
        packaging: 'Упаковочный',
        // Упаковочно-проверочный шаг материалы не списывает (Z-22)
        additional: 'Упаковочно-проверочный',
        picking: 'Комплектование',
        // ПО на складе не хранится: шаг только показывает сборщику ключи активации
        software: 'Используемое ПО',
      };
      return names[type] || type;
    },
    submit() {
      this.error = '';
      if (!this.form.name?.trim()) {
        this.error = 'Введите название шага';
        return;
      }
      if (!this.form.targetOperationId) {
        this.error = 'Выберите операцию';
        return;
      }
      this.$emit('confirm', {
        name: this.form.name.trim(),
        type: this.form.type,
        targetOperationId: this.form.targetOperationId,
      });
    },
  },
};
</script>
